import React, { useState, useEffect, FunctionComponent } from "react";
import Topbar from "../../Components/TopBar/TopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import { API_COLUMNS } from "../../Values/tables";

import { filterStatus, searchAPIItem, searchAPIItemAdmin } from "../../Values/utils";
import { setCurrentRoute } from "../../Redux/actions";

import CustomTable from "../../Components/CustomTable/CustomTable";
import ApiModal from "../../Components/Modals/ApiModal/ApiModal";
import { fetchApi, fetchApiTokensMongo, fetchApiTokensFilterValues } from "../../Services/organizations";
import styles from '../Analytics/Analytics.module.css'
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import Loading from "../../Components/Loading/Loading";
import { AirlineSeatLegroomExtraRounded } from "@mui/icons-material";
import { googleAnalytics } from "../../Services/users";
import { useLocation } from 'react-router-dom';

type props = {
  history: any;
  organizationId: any;
  authToken: string;
  user: any;
  filterObject: any;
  filterSort: any;
};

const ApiPanel: FunctionComponent<props> = ({ history, organizationId, authToken, user, filterObject, filterSort }) => {
  const [searchQuery, setsearchQuery] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [apiModal, setApiModal] = useState(false);
  const [API, setAPI] = useState<any[] | undefined>(undefined);
  const [status, setStatus] = useState("ALL");
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [edit, setEdit] = useState(false);
  const [editData, setEditData] = useState();
  const [lastPage, setLastPage] = useState(-1);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [count, setCount] = useState<any>(0);
  const [isFinished, setIsFinished] = useState(false);
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [isGACalled, setIsGACalled] = useState<any>(false);
    const [cRoute,setCRoute]=useState("") 

     const location = useLocation();
      
        useEffect(() => {
          dispatcher(setCurrentRoute(location.pathname))
          setCRoute(location.pathname)
        }, [location]);

  useEffect(() => {
    if (organizationId) {
      fetchApiTokensMongo(organizationId, (val) => setFilterData(val), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished);
    }
  }, [organizationId]);

  useEffect(() => {
    setIsFinished(false);
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if (authToken) {
      fetchApiTokensMongo(organizationId, (val) => setFilterData(val), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, false, pageSize, 1, false);
    }
  }, [filterObject, filterSort, searchQuery,authToken]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if (authToken) {
          fetchApiTokensMongo(organizationId, (val) => setFilterData(val), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, false, pageSize);
        }
      } else {
        if (authToken) {
          fetchApiTokensMongo(organizationId, (val) => setFilterData(val), authToken, setCount, filterObject, filterSort, pageSize, page, searchQuery, (val) => setLoad(val), filterData, isFinished, setIsFinished, true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken]);

  useEffect(() => {
    if(authToken){
      fetchApiTokensFilterValues(organizationId, authToken, dispatcher);
    }
  }, [organizationId,authToken])

  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('API_Tokens_Screen',user)
      }
    }
  },[user])

  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: "0px", backgroundColor: "white" }}>
        {load === true && <Loading />}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", backgroundColor: "white" }}>
          <Topbar
            history={history}
            title={"Add Api"}
            path={"/addUsers"}
            onChange={(val) => setsearchQuery(val)}
            filterText="Status"
            setColumnModal={(data) => setColumnModal(data)}
            show={false}
            showStatusBox={true}
            setApiModal={(data) => setApiModal(data)}
            setStatus={(status) => setStatus(status)}
            status={status}
          />
        </div>
        <div className={commonStyle.parent} style={{ minHeight: "450px" }}>
          {/* <CustomTable
          tableColumns={API_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="API"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setSearchedItem={(val) => setsearchQuery(val)}
          setApiModal={(data) => setApiModal(data)}
          setApiEdit={(data) => setEdit(data)}
          setApiData={(data) => setEditData(data)}
        /> */}
          <ApiCustomTable
            tableColumns={API_COLUMNS}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="API"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            // setSearchedItem={(val) => setsearchQuery(val)}
            setApiModal={(data) => setApiModal(data)}
            setApiEdit={(data) => setEdit(data)}
            setApiData={(data) => setEditData(data)}
            setPage={(val) => setPage(val)}
            setPageSize={(val) => setPageSize(val)}
            callApi={() => Promise.resolve()}
            pageSize={pageSize}
            page={page}
            isFinished={isFinished}
            totalCount={count}
            lastPage={lastPage}
          />
        </div>
      </div>
      {apiModal === true && (
        <ApiModal open={apiModal} close={() => setApiModal(false)} />
      )}
      {apiModal === true && edit === true && (
        <ApiModal
          open={apiModal}
          close={() => setApiModal(false)}
          edit={edit}
          editData={editData}
          editClose={() => setEdit(false)}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    organizationId: state.organization.id,
    organizationUsers: state.organizationUsers.data,
    authToken: state.user.authToken,
    user: state.user.data,
    filterObject: state.apiTokensFilter,
    filterSort: state.apiTokensSort,
  };
};
export default connect(mapStateToProps)(ApiPanel);
